<template>
<div class="workspace">
    <div class="draw_part" ref="drawpart" :class="toolcursor">
        <span class="drawtip" v-if="init">工作区</span>
        <div class="literally"></div>
    </div>
    <div :class="{'draw_part': !init,'pre_part':init,'bck-style-0':init&&bckStyle==0,'bck-style-1':init&&bckStyle==1,'bck-style-2':init&&bckStyle==2,'bck-style-3':init&&bckStyle==3}" ref="prepart">
        <span class="pretip" v-if="init">效果</span>
        <div class="literally"></div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            bckStyle: 0,
            isdraw: false,
            isfirst: true,
            init: false,
            loading: true,
            drawlc: '', //涂抹实例
            prelc: '', //预览实例
            rate: '', //真实图片与展示图片的比例
            showwidth: '', //展示图片的宽度
            showheight: '', //展示图片的高度
            canvasheight: '', //画布高度
            canvaswidth: '', //画布宽度
            initflag: false, //精细抠图标识
            timer: '', //计时器
            MaskCode: '',
            planNo: '',
            addr: '',
            host: '',
            hz:'',
            preimg: '', //预览图
            brushtype: 0, //笔刷类型
            lcpos: { //画布位移距离
                x: 0,
                y: 0
            },
            zoom: 1, //画布放大倍数
            penwidth: 100, //笔刷大小
            ispan: false, //移动功能标识
            rangepoint: 'rgba(9,153,0,0.8)', //范围指示器颜色
            tool: '',
            temptool: '',
            btnstatus: {
                back: false,
                forward: false
            },
            edgepoints: []
        }
    },
    mounted() {
        let that = this;
        //初始化画布大小
        that.setcanvassize();
        //加入监听随着窗口改变画布大小
        window.onresize = function () {
            that.setcanvassize();
        }

    },
    computed: {
        toolcursor() { //改变光标图案

            return {
                'normalcursor': this.tool == 'init',
                'pancursor': this.tool == 'pan',
                'savecursor': this.tool == 'save',
                'delcursor': this.tool == 'del',
                'erasercursor': this.tool == 'eraser',
                'repaircursor': this.tool == 'repair',
            }
        }
    },
    methods: {
        penactived(type) { //笔刷触发
            this.initpen(type);
        },
        initpen(type) { //重置笔刷
            this.drawlc.setTool(new LC.tools.Pencil(this.drawlc));
            this.ispan = false;
            this.drawlc.tool.strokeWidth = this.penwidth / this.zoom
            this.tool = type
            switch (type) {
                case 'init':
                    _hmt.push(['_trackEvent', '智能抠图', '·涂抹·点击']);
                    this.drawlc.setColor("primary", "rgba(9,153,0,0.5)")
                    this.rangepoint = "rgba(9,153,0,0.8)"
                    break;
                case 'save':
                    _hmt.push(['_trackEvent', '智能抠图', '·精细抠图·保留·点击']);
                    this.drawlc.setColor("primary", "rgba(9,70,177,0.5)")
                    this.rangepoint = "rgba(9,70,177,0.8)"
                    this.brushtype = 2
                    break;
                case 'del':
                    _hmt.push(['_trackEvent', '智能抠图', '·精细抠图·剔除·点击']);
                    this.drawlc.setColor("primary", "rgba(235,23,53,0.5)")
                    this.rangepoint = "rgba(235,23,53,0.8)"
                    this.brushtype = 1
                    break;
                case 'eraser':
                    _hmt.push(['_trackEvent', '智能抠图', '·精细抠图·橡皮擦·点击']);
                    this.drawlc.setColor("primary", "rgba(235,23,53,0.5)")
                    this.rangepoint = "rgba(235,23,53,0.8)"
                    this.brushtype = 3
                    break;
                case 'repair':
                    _hmt.push(['_trackEvent', '智能抠图', '·精细抠图·修复擦·点击']);
                    this.drawlc.setColor("primary", "rgba(9,70,177,0.5)")
                    this.rangepoint = "rgba(9,70,177,0.8)"
                    this.brushtype = 4
                    break;
            }
        },
        setcanvassize() { //设置画布大小
            var initheight = (document.documentElement.clientHeight || document.body.clientHeight) - 60;
            this.$refs.drawpart.style.height = initheight + 'px'
            this.$refs.prepart.style.height = initheight + 'px'
        },
        initcanvas() { //初始化画布
            let that = this
            that.$emit("initloading")
            if (that.init) { //判断是否为第一次初始化
                that.$emit("reupload")
                that.drawlc.teardown()
                that.prelc.teardown()
                Object.assign(that.$data, that.$options.data())
                that.init = true
            }

            that.tool = 'init'
            //设置图片初始值

            that.canvaswidth = that.$store.state.info.canvaswidth
            that.canvasheight = that.$store.state.info.canvasheight
            that.showheight = that.$store.state.info.showheight
            that.showwidth = that.$store.state.info.showwidth
            that.rate = that.$store.state.info.rate
            that.addr = that.$store.state.info.addr
            that.host = that.$store.state.info.host
            that.hz = that.$store.state.info.hz
            that.$store.commit('setdownaddr', that.addr)
            var backgroundImage = new Image()
            backgroundImage.crossOrigin = "";
            backgroundImage.src = that.host + that.addr+that.hz;
            backgroundImage.onload = function () {

                var pointer = LC.createShape('Point', {
                    x: 100,
                    y: 100,
                    size: 100,
                    color: 'rgba(0,255,0,0)'
                })

                //-------------------------------------涂抹画布------------------------------------------------

                //初始化涂抹画布
                that.drawlc = LC.init(document.getElementsByClassName('literally ')[0], {
                    backgroundShapes: [
                        LC.createShape(
                            'Image', {
                                x: that.$store.state.info.initX,
                                y: that.$store.state.info.initY,
                                image: backgroundImage,
                                scale: 1 / that.rate
                            })
                    ]
                })

                that.drawlc.setColor("primary", "rgba(9,153,0,0.5)")
                that.drawlc.tool.strokeWidth = 100;

                that.drawlc.saveShape(LC.createShape('LinePath', { //初始化范围点
                    points: [pointer, pointer],
                    smooth: false
                }));

                //监控绘画结束事件
                that.drawlc.on('drawEnd', function (tools) {
                    _hmt.push(['_trackEvent', '智能抠图', '·涂抹次数·点击']);
                    that.isdraw = false;
                    addeventmove()
                    that.sendimg()
                });
                //监控绘画开始事件
                that.drawlc.on('drawStart', function (tools) {
                    that.isdraw = true;
                    window.clearTimeout(that.timer)
                    removeeventmove()
                });
                //监控移动事件
                that.drawlc.on('pan', function (pos) {
                    that.lcpos.x = pos.x;
                    that.lcpos.y = pos.y;
                    that.changepos(pos.x, pos.y)
                });

                if (!that.init) { //如果不是第一次初始化则不再绑定鼠标移动
                    addeventmove()
                }

                function addeventmove() {
                    document.getElementsByClassName('literally')[0].addEventListener('mousemove', that.mousefollow, false)
                    document.getElementsByClassName('literally')[0].addEventListener('mousemove', that.premousefollow, false)
                }

                function removeeventmove() {
                    document.getElementsByClassName('literally')[0].removeEventListener('mousemove', that.mousefollow, false)
                }

                //-------------------------------------预览画布------------------------------------------------

                //初始化预览画布
                that.prelc = LC.init(document.getElementsByClassName('literally')[1], {
                    tools: [LC.tools.Eyedropper]
                })

                that.prelc.saveShape(LC.createShape(
                    'Image', {
                        x: that.$store.state.info.initX,
                        y: that.$store.state.info.initY,
                        image: backgroundImage,
                        scale: 1 / that.rate
                    }));

                that.prelc.saveShape(LC.createShape('LinePath', {
                    points: [pointer, pointer],
                    smooth: false
                }));

                document.addEventListener('keydown', function (event) { //按住空格切换成移动并储存当前工具
                    if (!that.isdraw) {
                        if (event.code === 'ControlLeft' && that.ispan === false) {
                            if (that.tool != 'pan') {
                                _hmt.push(['_trackEvent', '智能抠图', '·移动快捷键·点击']);
                                that.temptool = that.tool;
                                that.tool = 'pan'
                                that.rangepoint = "rgba(0,0,0,0)"
                                that.drawlc.setTool(new LC.tools.Pan(this.drawlc))
                            }
                        }
                        if (event.code === 'KeyZ' && event.ctrlKey) {
                            _hmt.push(['_trackEvent', '智能抠图', '·撤销快捷键·点击']);
                            that.back()
                        }
                        if (event.code === 'KeyY' && event.ctrlKey) {
                            _hmt.push(['_trackEvent', '智能抠图', '·恢复快捷键·点击']);
                            that.forward()
                        }
                    }
                })
                document.addEventListener('keyup', function (event) { //松开空格还原回原来的工具
                    if (!that.isdraw) {
                        if (event.code === 'ControlLeft' && that.ispan === false) {
                            that.initpen(that.temptool)
                            that.tool = that.temptool
                        }
                    }
                })

                that.init = true
                that.$emit("initloading")
            }

            this.$emit("firstinit");
        },
        premousefollow(e) { //预览鼠标移动事件
            let that = this;
            var pointer = LC.createShape('Point', {
                x: (e.clientX - that.lcpos.x) / that.zoom,
                y: ((e.clientY - 60) - that.lcpos.y) / that.zoom,
                size: that.penwidth / that.zoom,
                color: that.rangepoint
            })
            that.prelc.shapes[1] = LC.createShape('LinePath', {
                points: [pointer, pointer],
                smooth: false
            });
            that.prelc.setZoom(that.zoom)
        },
        mousefollow(e) { //主画布鼠标移动事件
            let that = this;
            var pointer = LC.createShape('Point', {
                x: (e.clientX - that.lcpos.x) / that.zoom,
                y: ((e.clientY - 60) - that.lcpos.y) / that.zoom,
                size: that.penwidth / that.zoom,
                color: that.rangepoint
            })
            that.drawlc.shapes[0] = LC.createShape('LinePath', {
                points: [pointer, pointer],
                smooth: false
            });
            that.drawlc.setZoom(that.zoom)
        },
        tocare() { //精准抠图
            _hmt.push(['_trackEvent', '智能抠图', '·精细抠图·点击']);
            let that = this;
            if (this.getAllData().length == 0) {
                this.$emit("hasmark", false)
                return;
            }

            this.$emit("hasmark", true)
            this.reset();
            window.setTimeout(() => {
                that.drawedgepoints()
            }, 0)

            this.penwidth = 30;
            this.drawlc.tool.strokeWidth = 30;

            this.initpen("del")
            this.initflag = true;

        },
        changepos(x, y) { //两区平移同步
            this.prelc.setPan(x, y)
        },
        sendimg() { //发送坐标
            let that = this;
            if (this.initflag) {
                send();
            } else {
                that.timer = setTimeout(send, 1000);
            }

            function send() {
                if (that.getAllData().length == 0) {
                    return;
                }
                that.$emit('psprocess', true)
                var tempMaskCode = ""
                var tempplanNo = ""
                if (that.initflag) {
                    tempMaskCode = that.MaskCode
                    tempplanNo = that.planNo
                }
                that.$ajax.post(that.ajaxbaseurl + '/api/matting/cut', {
                            MaskCode: tempMaskCode,
                            OssSourcePath: that.addr+that.$store.state.info.hz,
                            BrushType: that.brushtype,
                            BrushPoints: that.getAllData(),
                            planNo: tempplanNo
                        })
                    .then(function (res) {
                        if (res.data.code!==200) {
                            that.$emit('psprocess', false)
                            if (res.data.msg == '!bgdSamples.empty() && !fgdSamples.empty()') {
                                that.$emit("error", '请在图片区域内操作')
                                if (that.initflag) {
                                    that.drawlc.clear();
                                }
                            } else {
                                that.$emit("error", res.data.msg)
                            }
                            return;
                        }
                        that.edgepoints = res.data.result.contours
                        that.preimg = that.host + res.data.result.ossPngDstPath
                        that.MaskCode = res.data.result.maskCode
                        that.planNo = res.data.result.planNo
                        that.$store.commit('setdownaddr', {
                            png: res.data.result.ossPngDstPath,
                            jpg: res.data.result.ossJpgDstPath
                        })
                        that.$emit("firstdraw")
                        if (that.initflag) {
                            that.drawedgepoints();
                            that.btnstatus.back = res.data.result.hasBackOff;
                            that.btnstatus.forward = res.data.result.hasForward;
                            that.changebtnstatus(res.data.result.hasBackOff, res.data.result.hasForward)
                        }
                    })
            }
        },
        drawedgepoints() { //画出边缘
            let that = this;
            that.drawlc.clear();
            var pointer = LC.createShape('Point', {
                x: 100,
                y: 100,
                size: 100,
                color: 'rgba(0,255,0,0)'
            })
            that.drawlc.saveShape(LC.createShape('LinePath', { //初始化范围点
                points: [pointer, pointer],
                smooth: false
            }));
            for (var i in that.edgepoints) {
                var pointarr = [];
                for (var j in that.edgepoints[i]) {
                    var pointer = LC.createShape('Point', {
                        x: (that.edgepoints[i][j].X / that.rate) + (that.canvaswidth - that.showwidth) / 2,
                        y: (that.edgepoints[i][j].Y / that.rate) + (that.canvasheight - that.showheight) / 2,
                        size: 2,
                        color: '#fffa47'
                    })
                    pointarr.push(pointer)
                }

                that.drawlc.saveShape(
                    LC.createShape('LinePath', {
                        points: pointarr,
                        smooth: true
                    })
                );

            }
        },
        //获取画布所有坐标
        getAllData() {
            let that = this;
            var tempMaskPoints = [];
            for (var i in that.drawlc.shapes) {
                if (typeof (that.drawlc.shapes[i]) == "undefined") break;
                var flag = that.drawlc.shapes[i].points[0].color == "rgba(9,153,0,0.5)" || that.drawlc.shapes[i].points[0].color == 'rgba(9,70,177,0.5)' || that.drawlc.shapes[i].points[0].color == 'rgba(235,23,53,0.5)'
                if (flag) {
                    var temppath = '';
                    var type = 0
                    var path = ""
                    var pointSize = LC.shapeToJSON(that.drawlc.shapes[i]).data.pointSize
                    var pointdata = LC.shapeToJSON(that.drawlc.shapes[i]).data.smoothedPointCoordinatePairs;
                    for (var i in pointdata) {
                        var nowpath = parseInt((pointdata[i][0] - (that.canvaswidth - that.showwidth) / 2) * that.rate) + "," + parseInt((pointdata[i][1] - (that.canvasheight - that.showheight) / 2) * that.rate) + "|";
                        if (nowpath != temppath) {
                            path = path + nowpath;
                            temppath = nowpath
                        }
                    }
                    var brushsize = parseInt(pointSize * that.rate);
                    if (brushsize < 1) {
                        brushsize = 1;
                    }
                    tempMaskPoints.push({
                        BrushSize: brushsize,
                        PointStrs: path.slice(0, path.length - 1)
                    })
                }
            }
            return tempMaskPoints;
        },
        zoomin() { //放大
            this.zoom += 0.2;
            this.changezoom();
        },
        zoomout() { //缩小
            this.zoom -= 0.2;
            this.changezoom();
        },
        changezoom() {
            this.drawlc.setZoom(this.zoom)
            this.prelc.setZoom(this.zoom)
            this.lcpos.x = this.drawlc.position.x;
            this.lcpos.y = this.prelc.position.y;
            this.drawlc.tool.strokeWidth = this.penwidth / this.zoom
        },
        pan() { //移动
            this.rangepoint = "rgba(0,0,0,0)"
            this.ispan = true
            this.tool = "pan"
            this.drawlc.setTool(new LC.tools.Pan(this.drawlc))
        },
        sizechange(size) { //笔刷大小改变

            this.penwidth = size;
            this.drawlc.tool.strokeWidth = this.penwidth / this.zoom
        },
        reset() { //图片复位
            this.zoom = 1;
            this.drawlc.setZoom(1);
            this.drawlc.setPan(0, 0);
            this.prelc.setZoom(1);
            this.prelc.setPan(0, 0);
        },
        back() { //后退
            if (this.initflag) {
                if (this.btnstatus.back) {
                    this.bsopc(0)
                    return;
                }
            }
            if (this.getAllData().length === 0) {
                return;
            }
            this.drawlc.undo()
            if (this.getAllData().length === 0) {
                this.preimg = this.host + "/" + this.addr;
                return;
            }
            this.sendimg();
        },
        forward() { //前进
            if (this.initflag) {
                if (this.btnstatus.forward) {
                    this.bsopc(1)
                    return;
                }

            }
            this.drawlc.redo()
            this.sendimg()
        },
        changeback(index) {
            this.bckStyle = index;
        },
        changebtnstatus(back, forward) {
            this.$emit("changebtnstatus", {
                back: back,
                forward: forward
            })
        },
        bsopc(type) { //进行前进后退操作
            let that = this;
            that.$emit('psprocess', true)
            that.$ajax.post(that.ajaxbaseurl + '/api/matting/getrecord', {

                    MaskCode: that.MaskCode,
                    planNo: that.planNo,
                    type: type

                })
                .then(function (res) {
                    if (res.data.code!==200) {
                        that.$emit("error", res.data.msg)
                        return;
                    }
                    that.edgepoints = res.data.result.contours
                    that.$store.commit('setdownaddr', {
                            png: res.data.result.ossPngDstPath,
                            jpg: res.data.result.ossJpgDstPath
                        })
                    that.preimg = that.host + '/' + res.data.result.ossPngDstPath;
                    that.MaskCode = res.data.result.maskCode;
                    that.planNo = res.data.result.planNo
                    that.btnstatus.back = res.data.result.hasBackOff;
                    that.btnstatus.forward = res.data.result.hasForward;
                    that.changebtnstatus(res.data.result.hasBackOff, res.data.result.hasForward)
                    that.drawedgepoints();
                })

        }
    },
    watch: {
        preimg(val) {
            //大致为上面盖上2层，再把下面的2层抽掉
            let that = this;
            if (val != '') {
                var backgroundImage = new Image()
                backgroundImage.crossOrigin = ""
                backgroundImage.src = val;

                backgroundImage.onload = function () {
                    that.prelc.saveShape(LC.createShape(
                        'Image', {
                            x: that.$store.state.info.initX,
                            y: that.$store.state.info.initY,
                            image: backgroundImage,
                            scale: 1 / that.rate
                        }));
                    var pointer = LC.createShape('Point', {
                        x: 100,
                        y: 100,
                        size: 150,
                        color: 'rgba(0,255,0,0)'
                    })

                    that.prelc.saveShape(LC.createShape('LinePath', {
                        points: [pointer, pointer],
                        smooth: false
                    }));
                    that.prelc.shapes.splice(0, 2)
                    that.prelc.setZoom(that.zoom)
                    that.$emit('psprocess', false)
                }

            }
        }
    }
}
</script>

<style lang="scss">
.workspace {
    overflow: hidden;

    >div {
        position: relative;
        width: 50%;
        float: left;

        >span {
            position: absolute;
            font-size: 12px;
            padding: 6px 9px;
            background-color: rgba(55, 58, 62, .7);
            color: #fff;
            z-index: 999;
        }

        .drawtip {
            right: 0;
            border-bottom-left-radius: 3px;
            background-color: rgba(7, 99, 252, .7);
        }

        .pretip {
            left: 1px;
            border-bottom-right-radius: 3px
        }
    }

    .draw_part {
        background: #eee;
    }

    .pre_part {

        &::after {
            content: '';
            height: 100%;
            width: 1px;
            background: #fff;
            position: absolute
        }
    }

    .bck-style-0 {
        background: url("../assets/image/main/prebck.png");
    }

    .bck-style-1 {
        background: #fff;
    }

    .bck-style-2 {
        background: #000;
    }

    .bck-style-3 {
        background: #ccc;
    }

    .normalcursor {
        cursor: url("https://oss.fjdaze.com/public/plugin/cursor-normal.ico") 8 8, auto;
    }

    .erasercursor {
        cursor: url("https://oss.fjdaze.com/public/plugin/cursor-eraser.ico") 8 8, auto;
    }

    .repaircursor {
        cursor: url("https://oss.fjdaze.com/public/plugin/cursor-repair.ico") 8 8, auto;
    }

    .savecursor {
        cursor: url("https://oss.fjdaze.com/public/plugin/cursor-save.ico") 8 8, auto;
    }

    .delcursor {
        cursor: url("https://oss.fjdaze.com/public/plugin/cursor-del.ico") 8 8, auto;
    }

    .pancursor {
        cursor: url("https://oss.fjdaze.com/public/plugin/cursor-pan.ico") 8 8, auto;
    }
}
</style>
